import { Controller } from "@hotwired/stimulus";

// ブラウザバック時に非活性を維持するため、クリック後対象のsubmitボタンをすべて非活性化する
export default class extends Controller {
  static targets = ["button"];

  disable() {
    this.buttonTargets.forEach((btn) => {
      btn.disabled = true;
      btn.setAttribute("aria-disabled", "true");
    });
    setTimeout(() => {
      this.buttonTargets.forEach((btn) => {
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
      });
    }, 1100);
  }
}
